import React, {useEffect, useState} from "react";
import styles from './NotificationAdministration.module.scss';
import {DataGrid} from "@mui/x-data-grid";
import BroadcastNotification from "./BroadcastNotification";
import moment from "moment";
import {PROD_API_URL} from "../../constants/constants";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import { ReactComponent as TrashIcon } from "../../images/svg/trashIcon.svg";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";


const NotificationAdministration = () => {
    const [notifications, setNotifications] = useState();
    const [editNotification, setEditNotification] = useState();
    const [loading, setLoading] = useState(true);

    const notificationColumns = [
        { field: 'title', headerName: 'Title', flex: 1},
        { field: 'message', headerName: 'Message', flex: 1},
        { field: 'readCount', headerName: 'Read Count', width: 100},
        { field: 'type', headerName: 'Type', width: 80},
        {
            field: 'image',
            headerName: 'Image',
            width: 80,
            renderCell: (params) => (
                params.value ? <img className={styles.notificationImage} src={params.value} alt="profileImage"/> : ''
            )
        },
        { field: 'actionType', headerName: 'Action Type', width: 100},
        { field: 'channels', headerName: 'Channels', width: 100},
        { field: 'broadcastType', headerName: 'Broadcast Type', width: 100},
        { field: 'recipients', headerName: 'Recipients',width: 80},
        {
            field: 'createdAt',
            headerName: 'Created At',
            width: 220,
            renderCell: (params) => (
                moment.unix(params.value / 1000).format('YYYY-MM-DD , h:mm A')
            )
        },
        {
            field: 'delete',
            headerName: '',
            width: 60,
            renderCell: (params) => (
                <div>
                    <TrashIcon className={styles.trashIcon} onClick={() => removeNotification(params.row.id)}/>
                </div>
            )
        },
    ]

    useEffect(() => {
        fetchNotifications();
    }, []);

    const removeNotification = async (id) => {
        try {
            await fetch(PROD_API_URL + "/notification/remove", {
                "method": "POST",
                "headers": {"content-type": "application/json", "accept": "*"},
                "body": JSON.stringify({ id })
            });
            toast('Notification Deleted!', successToast);
            await fetchNotifications();
        } catch (e) {
            toast('Error deleting notification', errorToast);
            console.error(e);
        }
    }

    const fetchNotifications = async () => {
        fetch(PROD_API_URL + "/notifications/", {
            "method": "GET",
            "headers": {"content-type": "application/json", "accept": "*"},
        }).then(res=>res.json())
            .then((result)=>{
                setNotifications(result.data)
                setLoading(false);
            });
    }

    return (
        <div className={styles.notificationAdministrationContainer}>
            <div className={styles.notificationTable}>
                {loading ? <div className={styles.loadingContainer}>
                    <LoadingSpinner local/>
                </div> : <DataGrid
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    pageSizeOptions={[10, 15, 20]}
                    rows={notifications}
                    onCellDoubleClick={(params) => setEditNotification(params.row)}
                    columns={notificationColumns}
                />}
            </div>
            <div className={styles.notificationAdministrationFooter}>
                <BroadcastNotification notification={editNotification} setNotification={setEditNotification} fetchNotifications={fetchNotifications} />
            </div>
        </div>
    );
}

export default NotificationAdministration;
